// eslint-disable-next-line import/prefer-default-export
export const PlaceHolderMode = {
    NONE: 'none',   // placeholder手动隐藏模式
    PIC: 'pic',
    BODY: 'body',
    TXT: 'txt',
    TBL: 'tbl',
    SUBTITLE: 'subTitle',
    CTRTITLE: 'ctrTitle',
    TITLE: 'title',
    BLANK: 'blank',
    DATETIME: 'dt',
    FOOT: 'ftr',
    SLIDENUM: 'sldNum',
    CHART: 'chart',
    DGM: 'dgm',
    MEDIA: 'media',
    CLIPART: 'clipArt',
};
